// extracted by mini-css-extract-plugin
export var container = "NavigationItem-module--container--n+y2j";
export var disabled = "NavigationItem-module--disabled--Ihgh5";
export var next = "NavigationItem-module--next--mjL5H";
export var prev = "NavigationItem-module--prev--OpKR8";